import { initGraphQLTada } from 'gql.tada';
import type { introspection } from './graphql-env';

/**
 * Extract a single type from a GraphQL fragment based on its typename.
 *
 * Example:
 * type Props = {
 *   data: ExtractTypeByTypename<typeof MyFragment, 'MyType'>;
 * };
 */
export type ExtractTypeByTypename<
  TFragment extends { readonly __typename?: unknown },
  TTypename extends string,
> = Extract<TFragment, { readonly __typename?: TTypename }>;

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: {
    Date: string;
    Object: any;
    Upload: any;
  };
  disableMasking: true;
}>();

export type { FragmentOf, ResultOf, VariablesOf } from 'gql.tada';
export { readFragment } from 'gql.tada';
